/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchPosts.defs.js'
export * as $defs from './searchPosts.defs.js'
